import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import * as headerAction from '../../../../actionCreators/header';
import MainMenu from '../MainMenu/MainMenu';
import './Nav.scss';
// import './Navigation.scss';
import { pushDataLayerEvent } from '../../../../utils/DataLayer';
import { setDataAttr } from '../../../../utils/helper';

class Navigation extends Component {
  static propTypes = {
    navData: PropTypes.object,
    headerAction: PropTypes.object.isRequired,
    isMenuVisible: PropTypes.bool.isRequired,
  };

  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    // This fix is hide the menu/submenu when user click on any of the menu/submenu.
    if (!this.props.isMenuVisible) {
      this.props.headerAction.rerenderMenu(true);
    }
  }
  updateNavDtm = (type, section, subSection, link, cta, e, ctaName = null) => {
    this.props.headerAction.rerenderMenu(false);
    this.triggerDataLayerOnCtaClick(ctaName || type?.alt, e);
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.header.click.topNavClick(type, section, subSection, link, cta);
  };

  updateNavValueDtm = (type, section, subSection, link, e, ctaName) => {
    this.props.headerAction.rerenderMenu(false);
    this.triggerDataLayerOnCtaClick(ctaName || type?.alt, e);
    if (window.dtm.LenskartRewamp)
      window.dtm.LenskartRewamp.header.click.topNavClickValue(type, section, subSection, link);
  };
  // toggleMenu = value => {
  //     this.props.headerAction.rerenderMenu(value);
  // }
  // eslint-disable-next-line no-unused-vars
  triggerDataLayerOnCtaClick = (name, e) => {
    // e?.preventDefault();
    name = name?.trim().toLowerCase().replace(/[ ]+/gi, '-') || '';
    const data = {
      event: 'cta_click',
      cta_name: name,
      cta_flow_and_page: 'navigation-bar',
    };
    pushDataLayerEvent(data);
  };

  render() {
    const { navData, rightNavData, location, dataLocale, localeInfo } = this.props;
    return (
      <div className="no-padding navigation">
        {' '}
        {/* ${(isMenuHidden ? 'hide' : '')} */}
        <nav className="navigation_top layout center big-screen-wrapper">
          <div className="layout justify-content-between navigation-list margin-r8">
            {this.props.isMenuVisible && (
              <MainMenu
                dataLocale={dataLocale}
                localeInfo={localeInfo}
                location={location}
                navData={navData}
                triggerDataLayerOnCtaClick={this.triggerDataLayerOnCtaClick}
                updateNavDtm={this.updateNavDtm}
                updateNavValueDtm={this.updateNavValueDtm}
              />
            )}
          </div>
          <div className="layout justify-content-between navigation_right">
            {rightNavData &&
              rightNavData.map((rigtNav, index) => {
                const dataAttr =
                  rigtNav.gaObj && Object.keys(rigtNav.gaObj).length > 0
                    ? setDataAttr(rigtNav.gaObj)
                    : null;
                return (
                  <div
                    key={index}
                    className={index !== rightNavData.length - 1 ? 'margin-r4' : 'margin-r-4'}
                  >
                    {rigtNav.url && rigtNav.url.indexOf('lenskart.com') === -1 ? (
                      <Link
                        to={rigtNav.url}
                        onClick={e => this.triggerDataLayerOnCtaClick(rigtNav.alt, e)}
                      >
                        <div className="img-wrapper">
                          <img
                            {...dataAttr}
                            alt={rigtNav.alt}
                            className="getGaData"
                            src={rigtNav.src}
                          />
                        </div>
                      </Link>
                    ) : (
                      <a
                        className=""
                        href={rigtNav.url}
                        onClick={e =>
                          this.updateNavDtm(rigtNav, rightNavData, null, null, rigtNav.cta, e)
                        }
                      >
                        <div className="img-wrapper">
                          <img
                            {...dataAttr}
                            alt={rigtNav.alt}
                            className="getGaData"
                            src={rigtNav.src}
                          />
                        </div>
                      </a>
                    )}
                  </div>
                );
              })}
          </div>
        </nav>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isMenuVisible: state.header.isMenuVisible,
  dataLocale: state.locale,
  localeInfo: state.common.localeInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    headerAction: bindActionCreators(headerAction, dispatch),
  };
}

Navigation.defaultProps = {
  navData: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Navigation);
